import { useEffect, useState } from 'react';

import { RULE_ERROR_FIELDS, ruleErrorField, ruleInputSignature, unsatisfiableRule } from './Modifiers.saveGuards';

export default function useRuleError({ methods, values, message }) {
  const [serverRefused, setServerRefused] = useState(false);
  const { isSubmitted } = methods.formState;
  const field = unsatisfiableRule(values) || serverRefused ? ruleErrorField(values) : null;
  const ruleInputs = ruleInputSignature(values);

  useEffect(() => {
    setServerRefused(false);
  }, [ruleInputs]);

  useEffect(() => {
    if (!isSubmitted) return;

    methods.clearErrors(RULE_ERROR_FIELDS);
    if (field) methods.setError(field, { type: 'validate', message });
  }, [field, isSubmitted, message, methods]);

  return { setServerRefused };
}
